<template>
  <v-container grid-list-md>
    <h3 class="headline mb-0">Fortschritt</h3>
    <v-timeline dense>
      <v-timeline-item
          :color="getCheckpointStatus(checkpoint)"
          :key="checkpoint.id"
          v-for="checkpoint in checkpoints"
      >
        <v-layout>
          <v-flex xs6>{{ checkpoint.title }}</v-flex>
          <v-flex xs4>{{ formatDate(checkpoint.dateTime) }}</v-flex>
          <v-flex xs2>{{ checkpoint.speed }} km/h</v-flex>
        </v-layout>
      </v-timeline-item>
    </v-timeline>
    <h3 class="headline mb-0" v-if="canceled === false">&Oslash; Geschwindigkeit
      <SpeedIndex :speed="averageSpeed"></SpeedIndex> bei Kilometer {{ calculatedPosition }}
    </h3>
    <h3 class="headline mb-0" v-if="canceled === false">Geschätzte Ankunftszeit im Ziel: {{ formatDate(estimatedFinishTime) }} bis {{ formatDate(estimatedFinishTimeBuffer) }}</h3>
  </v-container>
</template>

<script>
  import SpeedIndex from "@/components/SpeedIndex.vue";
  import participantService from "@/services/ParticipantService";

  export default {
    name: 'ParticipantProgress',
    components: {SpeedIndex},
    props: {
      participant: Object
    },
    data: function () {
      return {
        checkpoints: [],
        averageSpeed: 0,
        totalLength: 0,
        totalTime: 0,
        calculatedPosition: 0,
        canceled: false,
        estimatedFinishTime: null,
        estimatedFinishTimeBuffer: null
      }
    },
    computed: {
      categories() {
        return this.$store.state.categories
      }
    },
    methods: {
      getCheckpointStatus(checkpoint) {
        if (checkpoint.canceled) {
          return 'error'
        }

        return 'success'
      },
      formatDate(date) {
        if (date !== null) {
          return new Date(date).toLocaleString();
        }
      }
    },
    mounted() {
      participantService.getSpeed(this.participant.id).then(response => {
        this.checkpoints = response.data.checkpoints;
        this.averageSpeed = response.data.averageSpeed;
        this.totalLength = response.data.totalLength;
        this.totalTime = response.data.totalTime;
        this.calculatedPosition = response.data.calculatedPosition;
        this.canceled = response.data.canceled;
        this.estimatedFinishTime = response.data.estimatedFinishTime;
        this.estimatedFinishTimeBuffer = response.data.estimatedFinishTimeBuffer;
      })
    }
  }
</script>

<style>

</style>
